module.exports = __webpack_public_path__ + "img/image_2.bcd8c6b3.jpg";